import React, {useEffect, useState} from "react"
import {Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography, Alert} from "@mui/material"
import {Cancel as CancelIcon, ExpandMore as ExpandMoreIcon} from "@mui/icons-material"
import {useLocation} from "react-router-dom"

import {NoActivities} from "./NoActivities"
import {ActivitiesList} from "./ActivitiesList"

import {BackToSearch} from "@indebted/components/BackToSearch"
import {api} from "@indebted/api"
import {LoadingPage} from "@indebted/components/Loading"

function Account({
	account,
	accountDetailsComponent,
}: {
	account: {ID: string; Closed: boolean}
	accountDetailsComponent: React.ReactNode
}) {
	const [activitiesExpanded, setActivitiesExpanded] = React.useState(false)
	const [activitiesComponent, setActivitiesComponent] = useState<JSX.Element>(<LoadingPage />)
	const [detailsExpanded, setDetailsExpanded] = React.useState(true)

	useEffect(() => {
		api.account
			.activities(account.ID)
			.then((activities) => {
				const activitiesArray = activities
				if (activitiesArray.Activities.length === 0) {
					setActivitiesComponent(<NoActivities>No activities</NoActivities>)
				} else {
					setActivitiesComponent(<ActivitiesList activities={activitiesArray} />)
				}
			})
			.catch(() => {
				setActivitiesComponent(<NoActivities>Something went wrong</NoActivities>)
			})
	}, [account.ID])

	const location = useLocation()
	const params = new URLSearchParams(location.search)
	const backButton = () => (
		<Box p={3}>
			<Grid container justifyContent="flex-end">
				<BackToSearch backURL={params.get("accountBack") || ""} />
			</Grid>
		</Box>
	)

	const handleExpandDetails = () => {
		setDetailsExpanded(!detailsExpanded)
		setActivitiesExpanded(false)
	}
	const detailsSection = () => (
		<Accordion expanded={detailsExpanded} onChange={handleExpandDetails}>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<Typography variant="body1" color="textSecondary" display="block">
					Details
				</Typography>
			</AccordionSummary>

			<AccordionDetails>{accountDetailsComponent}</AccordionDetails>
		</Accordion>
	)

	const handleExpandActivities = () => {
		setActivitiesExpanded(!activitiesExpanded)
		setDetailsExpanded(false)
	}
	const activitiesSection = () => (
		<Accordion expanded={activitiesExpanded} onChange={handleExpandActivities}>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<Typography variant="body1" color="textSecondary" display="block">
					Activities
				</Typography>
			</AccordionSummary>

			<AccordionDetails>{activitiesComponent}</AccordionDetails>
		</Accordion>
	)

	return (
		<>
			{backButton()}
			{account.Closed && (
				<Alert severity="error" icon={<CancelIcon />}>
					Account closed for collection
				</Alert>
			)}
			{detailsSection()}
			{activitiesSection()}
		</>
	)
}

export {Account}
